var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7499 7.54997C17.5099 7.50997 17.2599 7.49998 16.9999 7.49998H6.99994C6.71994 7.49998 6.44994 7.51998 6.18994 7.55998C6.32994 7.27998 6.52994 7.02001 6.76994 6.78001L10.0199 3.52C11.3899 2.16 13.6099 2.16 14.9799 3.52L16.7299 5.28996C17.3699 5.91996 17.7099 6.71997 17.7499 7.54997Z",
    fill: "#F0F8FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M2 16.86V12.5C2 9.78 3.64 7.88 6.19 7.56C6.45 7.52 6.72 7.5 7 7.5H17C17.26 7.5 17.51 7.50999 17.75 7.54999C20.33 7.84999 22 9.76 22 12.5V17.5C22 20.26 19.76 22.5 17 22.5H7.63H7C4.24 22.5 2 20.26 2 17.5V16.86Z",
    fill: "#F0F8FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 13H19C17.9 13 17 13.9 17 15C17 16.1 17.9 17 19 17H22",
    fill: "#F0F8FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletSearch);
export default __webpack_public_path__ + "static/media/wallet-search.2dcb44ef6740decb8d89b6650f97e261.svg";
export { ForwardRef as ReactComponent };